export default "__VITE_ASSET__CIJ6GZKz__"